import axios from '../marketplace/axios-marketplace';

const getBanners = params => axios.get('/banners', {
  params,
});

export default {
  getBanners,
};
